import React from 'react';
import { motion } from 'framer-motion';
export function CheStructureScreen() {
  return <section className="min-h-screen w-full bg-white flex flex-col items-center justify-center px-6 py-20" data-id="element-62">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="w-full max-w-5xl" data-id="element-63">
        <h2 className="text-3xl md:text-5xl font-bold text-slate-900 text-center mb-10" data-id="element-64">
          How this applies to Chronic Hand Eczema
        </h2>
        <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-200" data-id="element-65">
          <img src="https://cdn.magicpatterns.com/uploads/hWn3iYdCbvAVAjirhHWees/Screenshot_2026-04-09_at_11.47.39.png" alt="CHE 1 Snak Structure Overview — showing the flow from initial hook through engagement steps to the final CTA" className="w-full h-auto" data-id="element-66" />
        </div>
      </motion.div>
    </section>;
}